import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Logo } from '@/components/shared/logo';
import { ROUTES } from '@/lib/constants';
import { useIsAuthenticated } from '@/stores/auth-store';
import { cn } from '@/lib/utils';

const links = [
  { to: '/#features', label: 'Features' },
  { to: '/#how', label: 'How it works' },
  { to: '/#pricing', label: 'Pricing' },
  { to: '/help', label: 'Help' },
];

export function PublicNav() {
  const [open, setOpen] = useState(false);
  const authed = useIsAuthenticated();

  return (
    <header className="sticky top-0 z-40 w-full border-b border-(--color-border)/80 glass">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to={ROUTES.home} className="flex items-center" aria-label="Tally home">
          <Logo />
        </Link>

        <nav className="hidden gap-8 md:flex" aria-label="Primary">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                cn(
                  'text-sm font-medium text-(--color-muted-foreground) transition-colors hover:text-(--color-foreground)',
                  isActive && 'text-(--color-foreground)',
                )
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          {authed ? (
            <Button asChild>
              <Link to={ROUTES.dashboard}>Go to app</Link>
            </Button>
          ) : (
            <>
              <Button variant="ghost" asChild>
                <Link to={ROUTES.login}>Sign in</Link>
              </Button>
              <Button variant="gradient" asChild>
                <Link to={ROUTES.signup}>Get started</Link>
              </Button>
            </>
          )}
        </div>

        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X /> : <Menu />}
        </Button>
      </div>

      {open ? (
        <div className="border-t border-(--color-border) md:hidden">
          <div className="space-y-1 px-4 py-3">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-2 text-sm font-medium text-(--color-foreground) hover:bg-(--color-muted)"
              >
                {link.label}
              </Link>
            ))}
            <div className="mt-3 flex gap-2">
              {authed ? (
                <Button className="flex-1" asChild>
                  <Link to={ROUTES.dashboard}>Go to app</Link>
                </Button>
              ) : (
                <>
                  <Button className="flex-1" variant="outline" asChild>
                    <Link to={ROUTES.login}>Sign in</Link>
                  </Button>
                  <Button className="flex-1" variant="gradient" asChild>
                    <Link to={ROUTES.signup}>Get started</Link>
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}
